/**
 * WordPress Dependencies
 */
import {
	store,
	getContext,
	getServerContext,
	getElement,
} from '@wordpress/interactivity';

store('prc-rls/religious-tree', {
	state: {
		get traditionPercentage() {
			const context = getContext();
			const { traditionPercentage } = context;
			return traditionPercentage === 0
				? '<1%'
				: `${traditionPercentage}%`;
		},
	},
	actions: {
		showMoreMobile: () => {
			const context = getContext();
			context.showMoreMobileExpanded = !context.showMoreMobileExpanded;
		},
		toggleItemExpansion: () => {
			const context = getContext();
			context.activeItemNode =
				context.activeItemNode === context.item?.name
					? null
					: context.item?.name;

			// Force the showMoreExpanded from the provider to be true whenever clicking in a node.
			context.showMoreExpanded = true;
		},
		toggleNestedExpansion: () => {
			const context = getContext();
			context.activeNestedNode =
				context.activeNestedNode === context.nested?.name
					? null
					: context.nested?.name;

			// Force the showMoreExpanded from the provider to be true whenever clicking in a node.
			context.showMoreExpanded = true;
		},
	},
	callbacks: {
		initTreeData: () => {
			const context = getContext();
			context.treeData.forEach((item) => {
				// if (item.is_active) {
				// 	context.treeHasActiveItem = true;
				// }
				if (item.children) {
					item.children.forEach((nested) => {
						if (nested.is_active) {
							// context.treeHasActiveItem = true;
							// Make sure the parent is expanded as well.
							context.activeItemNode = item?.name;
						}
						if (nested.children) {
							nested.children.forEach((subNested) => {
								if (subNested.is_active) {
									// context.treeHasActiveItem = true;
									// Make sure the parent is expanded as well.
									context.activeNestedNode = nested?.name;
									context.activeItemNode = item?.name;
								}
							});
						}
					});
				}
			});
		},
		watchForServerUpdates: () => {
			const serverContext = getServerContext();
			const context = getContext();
			if (serverContext.treeData !== context.treeData) {
				context.treeData = serverContext.treeData;
			}
			if (
				serverContext.traditionPercentage !==
				context.traditionPercentage
			) {
				context.traditionPercentage = serverContext.traditionPercentage;
			}
		},
		getBarWidth: () => {
			const context = getContext();
			const width = context.item?.percent?.value ?? 25;
			return `width: ${width}%`;
		},
		isLinkActive: () => {
			// This is much simpler, does the context url match the current url?
			// If so then this is the active tree link. Let's put a icon on it.
			const currentUrl = window.location.href.split('?')[0];
			const context = getContext();
			if (undefined !== context.deep) {
				return context.deep.url === currentUrl;
			}
			if (undefined !== context.nested) {
				return context.nested.url === currentUrl;
			}
			if (undefined !== context.item) {
				return context.item.url === currentUrl;
			}
			return false;
		},
		isItemExpanded: () => {
			const context = getContext();
			const { activeItemNode, item } = context;
			// Check if item has a name property, if it does not then return false.
			if (!item?.name) {
				return false;
			}
			return activeItemNode === item.name;
		},
		isNestedExpanded: () => {
			const context = getContext();
			const { activeNestedNode, nested } = context;
			// Check if nested has a name property, if it does not then return false.
			if (!nested?.name) {
				return false;
			}
			return activeNestedNode === nested.name;
		},
		hasItemChildren: () => {
			const context = getContext();
			const { item } = context;
			if (!item) {
				return false;
			}
			const { children } = item;
			return children.length > 0;
		},
		hasNestedChildren: () => {
			const context = getContext();
			const { nested } = context;
			if (!nested) {
				return false;
			}
			const { children } = nested;
			return children.length > 0;
		},
		hideItemChildren: () => {
			const context = getContext();
			const { item } = context;
			if (!item) {
				return false;
			}
			const { children } = item;
			return children.length === 0;
		},
		hideNestedChildren: () => {
			const context = getContext();
			const { nested } = context;
			if (!nested) {
				return false;
			}
			const { children } = nested;
			return children.length === 0;
		},
		getCircleChartStrokeDashArray: () => {
			const context = getServerContext();
			const { traditionPercentage } = context;
			return `${(traditionPercentage * 1.884).toFixed(1)} 188.4`;
		},
		changeEmptyLinksToSpans: () => {
			const { ref } = getElement();
			// Check if context.nested exists...
			// check if ref has an href with value...
			if (ref.getAttribute('href') === null) {
				const newElement = document.createElement('span');
				newElement.innerHTML = ref.innerHTML;
				ref.replaceWith(newElement);
			}
		},
		updateShowMoreMobileText: () => {
			const context = getContext();
			context.showMoreMobileText = context.showMoreMobileExpanded
				? 'Show less'
				: 'Show more';
		},
	},
});
